import { render, staticRenderFns } from "./Tipo_facturar.vue?vue&type=template&id=5fbcfe1f"
import script from "./Tipo_facturar.vue?vue&type=script&lang=js"
export * from "./Tipo_facturar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports